import { useEffect, useState, useRef, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { useGlobalSpinnerActionsContext } from "./../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";
import {
  useAMGSelectedContext,
  useSearchQueryContext,
  usePageSizeContext,
  usePageSizeActionContext,
  useCurrentPageContext,
  useCurrentPageActionContext,
  useSearchQueryActionContext,
  useMainGridSortContext,
  useMainGridSortActionContext,
  useSelectedFunContext,
} from "./../../../Context/GlobalContext";

import equipmentGroupConstants from "./../../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "./../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "./../../../Stores/EquipmentGroupStore";

import SearchBox_new from "./../../FilterOptions/SearchComponent/SearchBox_new";
import Paginator from "./../../Pagging/Paginator";
import _ from "lodash";
import { useSelectedConfigActionContext } from "./../../../Context/GlobalContext";
import GridTable from "../../ReusableComponent/GridTable/GridTable";
import HeaderBar from "../../ReusableComponent/Header/HeaderBar";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";

import {
  useSelectedFilterActionsContext,
  useSelectedFilterContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import GridColumnSettingControl from "../../FilterOptions/GridColumnSettingControl";
import { equipmentClick } from "../Equipment Selected/EquipmentClick";

import MessageBox from "../../MessageBox/MessageBox";
import { toast } from "react-toastify";

const NIOAnlageUebersicht = ({ fonctionsname, fonctionid }) => {
  //--context
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const selectedAnlageG = useAMGSelectedContext();

  const searchQuery = useSearchQueryContext();
  const UpdateSearchQuery = useSearchQueryActionContext();

  const pageSize = usePageSizeContext();
  const currentPage = useCurrentPageContext();

  const selectedFilter = useSelectedFilterContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();

  const itemSelectedFilter = useItemSelectedFilterContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();

  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();

  const sortBy = useMainGridSortContext();
  const UpdateSortBy = useMainGridSortActionContext();

  const selectedFuncId = useSelectedFunContext();
  const updateSelectedConfig = useSelectedConfigActionContext();

  const navigate = useNavigate();
  //variable
  const isMountedRef = useRef(null);
  const [data, setData] = useState(null);
  const [renderMe, setRenderMe] = useState(null);

  const [queryRefresh, setQueryRefresh] = useState(0);
  const [clearfilter, setClearFilter] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxText, setMessageBoxText] = useState({});
  const [msgButtons, setMsgButtons] = useState([]);
  const [exportData, setExportData] = useState(null);
  const [openSearchBox, setOpenSearchBox] = useState(false);
  const [columns, setColumns] = useState(null);

  const [tableData, setTableData] = useState({
    data: [],
    headerName: [],
    headers: {},
    filterName: [],
  });
  const [gridAction, setGridAction] = useState({
    actionName: [],
    functionHandler: "",
  });
  const [paginatorData, setpaginatorData] = useState({
    pageCount: "",
    pageSize: "",
    firstRowOnPage: "",
    lastRowOnPage: "",
    rowCount: "",
    rowLength: 0,
  });
  const [_orginalResponse, set_orginalResponse] = useState([]);
  const [renderTable, setRenderTable] = useState("");

  const headerBarControl = {
    clientFilter: true,
    filter: true,
    actionList: true,
    isPaginator: true,
  };
  const [dropValueToHeader, setDropValueToHeader] = useState([]);
  const [disabledSavedFilter, setDisabledSavedFilter] = useState(false);
  const [tablefunctions, setTablefunctions] = useState(null);
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const currentPageRef = useRef();
  currentPageRef.current = currentPage;
  const reportCode = "NIOEquip";
  // Region method

  const resetFilter = (e) => {
    e.preventDefault();
    setOpenSearchBox(false);
  };

  const openSearchBoxEvent = (e) => {
    e.preventDefault();
    setOpenSearchBox(true);
  };

  const closeMsg = () => {
    setOpenSearchBox(false);
    setMessageBoxOpen(false);
  };

  const ExportEvent = (value) => {
    setGlobalSpinner(true);
    setMessageBoxOpen(false);
    const buildOption = value;
    const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
    equipmentGroupActions.getExportDaten(
      selectedAnlageG,
      buildOption,
      itemSelectedFilter,
      reportCode,
      FilterId,
    );
  };

  const ExportOhneBilderEvent = () => {
    ExportEvent("none");
  };

  const downloadEvent = (event) => {
    event.preventDefault();
    const exportOption = "none";
    setMessageBoxText({
      title: localization.exportTitle,
      msg: localization.exportMsg1 + "\r\n" + localization.exportMsgNb,
      anlageID: 0,
    });

    setMsgButtons([
      { title: localization.cancelbutton, func: closeMsg },
      { title: localization.ok, func: ExportOhneBilderEvent },
    ]);
    setMessageBoxOpen(true);
  };

  const requestSort = (key) => {
    UpdateSortBy(key);
  };

  const loadData = () => {
    if (sortBy.key !== "") {
      setGlobalSpinner(true);
      const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
      if (itemSelectedFilter.length == 0) {
        setClearFilter(true);
      }
      equipmentGroupActions.getEquipmentList2(
        reportCode,
        sortBy.order,
        selectedAnlageG,
        parseInt(currentPage),
        parseInt(pageSize),
        sortBy.key,
        FilterId,
        itemSelectedFilter,
      );
      GridColumn_SettingActions.getSaveFilterList(selectedAnlageG, reportCode);
    }
  };

  const fetchData = useCallback(() => {
    if (selectedAnlageG !== null && selectedAnlageG !== undefined) {
      setGlobalSpinner(true);
      loadData();
    }
  }, [currentPage, pageSize, selectedAnlageG, searchQuery, sortBy]);

  //--endRegion Method

  //Region UseEffect
  useEffect(() => {
    isMountedRef.current = true;

    if (isMountedRef.current && selectedFuncId == 5) {
      fetchData();
    }
    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    if (refresh === 1) {
      setGlobalSpinner(true);
      loadData();
    }

    return () => {
      setRefresh(0);
    };
  }, [refresh]);

  useEffect(() => {
    let _renderMe = null;
    if (data !== null && data !== undefined) {
      let headerName = [];
      let _header = data.headers;
      let _rows = data.rows;
      let _idPos;
      let _action = data.actions;
      _header.map((item) => {
        headerName.push(item.name);
      });
      headerName.map((item, index) => {
        if (item === "ID") {
          _idPos = index;
        }
      });
      setGridAction({
        actionName: _action,
        functionHandler: handleFunctionCall,
      });
      const _page = data.pagingInfo;
      const _last = (_page.currentPage - 1) * _page.pageSize + data.rows.length;
      const _first = (_page.currentPage - 1) * _page.pageSize + 1;
      setColumns(data.filters);
      set_orginalResponse({
        data: _rows,
        headerName: headerName,
        headers: _header,
        sortBy: sortBy,
        _idPos: _idPos,
      });
      setTableData({
        data: _rows,
        headerName: headerName, //body.results,
        headers: _header,
        sortBy: sortBy,
      });
      setpaginatorData({
        pageCount: data.pagingInfo.pageCount,
        lastRowOnPage: _last,
        firstRowOnPage: _first,
        rowCount: data.pagingInfo.rowCount,
        pageSize: data.pagingInfo.pageSize,
        func1: UpdateCurrentPage,
        func2: UpdatePageSize,
        activePage: data.pagingInfo.currentPage,
        rowLength: data.rows.length,
      });
      setShowSearchDialog(false);
    } else {
      setShowSearchDialog(true);
    }
    // setRenderMe(_renderMe);
    return () => {
      setRenderMe(null);
    };
  }, [data]);

  useEffect(() => {
    const _renderTable = (
      <GridTable
        data={tableData}
        handleAction={handleAction}
        requestSort={requestSort}
      />
    );
    setRenderTable(_renderTable);
  }, [tableData]);

  useEffect(() => {
    function getColSettingSaveSuccess() {
      var res = gridColSettingStore.getsaveGridSettingNIOResult();
      if (res) {
        setShowFilterMenu(false);

        toast.success(localization.gridColumnSetting.saveSuccessMsg);
        setClearFilter(true);
        setDropValueToHeader([]);
        updateSelectedFilter("");
        UpdateSortBy("InventarNr");
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
      }
    }

    function getColSettingSaveFailure() {
      var res = gridColSettingStore.getsaveGridSettingNIOResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_NIO_SUCCESS,
      getColSettingSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_NIO_FAILURE,
      getColSettingSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_NIO_SUCCESS,
        getColSettingSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_NIO_FAILURE,
        getColSettingSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getFilterSaveSuccess() {
      var res = gridColSettingStore.getSavedFilterNIOResult();
      if (res) {
        setShowFilterMenu(false);
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
        toast.success(localization.gridColumnSetting.filterSave);
        updateSelectedFilter([res]);
        GridColumn_SettingActions.getSaveFilterList(
          res.equipmentGroupId,
          reportCode,
        );
        setDropValueToHeader([]);
      }
    }

    function getFilterSaveFailure() {
      var res = gridColSettingStore.getSavedFilterNIOResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_NIO_SUCCESS,
      getFilterSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_NIO_FAILURE,
      getFilterSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_NIO_SUCCESS,
        getFilterSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_NIO_FAILURE,
        getFilterSaveFailure,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      var _details = equipmentGroupStore.getEquipmentNIOListGrid();
      setData(_details);
      setGlobalSpinner(false);
      closeMsg();
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_SUCCESS,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_SUCCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setData(null);
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_FAILURE,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getNIoExport();
      setExportData(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_NIO_SUCCESS,
      updatData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_NIO_SUCCESS,
        updatData,
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getNIoExport();
      toast.error(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_NIO_FAILURE,
      updatData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_NIO_FAILURE,
        updatData,
      );
    };
  }, []);

  useEffect(() => {
    if (exportData !== null && exportData !== undefined) {
      // const blob = new Blob([exportData.data], {
      //   type: 'text/csv;charset=UTF-8,'
      // });
      // const url = window.URL.createObjectURL(blob);

      const url = window.URL.createObjectURL(exportData);

      let a = document.createElement("a");

      a.hidden = "";
      a.href = url;
      a.download = localization.NIOEquipments + ".xlsx"; //'Export.csv';
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, [exportData]);

  useEffect(() => {
    function getSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilterListNIOResult();
      if (res.length > 0) {
        setDropValueToHeader(res);
      } else {
        setDropValueToHeader([]);
      }
    }

    function SaveFilterResultFailure() {}

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_SUCCESS,
      getSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_FAILURE,
      SaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_SUCCESS,
        getSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_NIO_FAILURE,
        SaveFilterResultFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getEquipListSaveFilterSuccess() {
      var res = gridColSettingStore.getNIOEquListOnFilterResult();
      if (res) {
        setData(res);
      }
      setGlobalSpinner(false);
    }

    function getEquipListSaveFilterFailure() {
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_NIO_SUCCESS,
      getEquipListSaveFilterSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_NIO_FAILURE,
      getEquipListSaveFilterFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_NIO_SUCCESS,
        getEquipListSaveFilterSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_NIO_FAILURE,
        getEquipListSaveFilterFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getDelSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilNIODelResult();
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      toast.success(localization.delSuccess);
      if (currentPageRef.current != 1) {
        UpdateCurrentPage(1);
      } else {
        UpdateSortBy("InventarNr");
      }
      setGlobalSpinner(false);
    }

    function getDelSaveFilterResultFailure() {
      const res = gridColSettingStore.getsaveFilNIODelResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_NIO_SUCCESS,
      getDelSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_NIO_FAILURE,
      getDelSaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_NIO_SUCCESS,
        getDelSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_NIO_FAILURE,
        getDelSaveFilterResultFailure,
      );
    };
  }, []);

  /**-----------------------------------------listner filter value on FilterID Start---------------------------------------*/
  useEffect(() => {
    function getSaveFilterValueSuccess() {
      var res = gridColSettingStore.getSavedFilterValueNIOResult();
      if (res.length > 0) {
        updateListSelectedFilter(res);
      } else {
        updateListSelectedFilter([]);
        setGlobalSpinner(false);
      }
    }

    function getSaveFilterValueFailure() {
      setGlobalSpinner(false);
      updateListSelectedFilter([]);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_NIO_SUCCESS,
      getSaveFilterValueSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_NIO_FAILURE,
      getSaveFilterValueFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_NIO_SUCCESS,
        getSaveFilterValueSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_NIO_FAILURE,
        getSaveFilterValueFailure,
      );
    };
  }, []);

  /**-----------------------------------------listner filter value on FilterID End---------------------------------------*/

  function handleFilterMenu() {
    setGlobalSpinner(true);
    setShowFilterMenu(true);
  }

  function handleFunctionCall(e, functionName) {
    switch (functionName) {
      case "DataConfiguration":
        handleFilterMenu();
        break;
      case "ExcelExport":
        downloadEvent(e);
        break;
    }
  }
  const handleRowClicked = (row) => {
    sessionStorage.setItem("eqId", row.id);
    sessionStorage.setItem("invnr", row.inventarnr);
    const path = equipmentClick(row, fonctionid, fonctionsname);
    navigate(path);
  };

  function handleAction(actioName, rowselected, headerNameList) {
    const _row = rowselected;
    let id,
      inventarnr,
      eqBez = "";
    headerNameList.map((item, index) => {
      if (item.name.toLowerCase() === "id") {
        id = parseInt(_row[index].value);
      }
      if (item.name.toLowerCase() === "inventarnr") {
        inventarnr = _row[index].value;
      }
      if (item.name.toLowerCase() === "bezeichnung") {
        eqBez = _row[index].value;
      }
    });
    const row = { id: id, inventarnr: inventarnr, bezeichnung: eqBez };
    handleRowClicked(row);
  }
  function handleFilterLocal(filterResult) {
    setTableData({
      data: filterResult,
      headerName: _orginalResponse.headerName, //body.results,
      headers: _orginalResponse.headers,
      sortBy: sortBy,
    });
  }

  const handleDropDownSelChange = (item) => {
    if (item !== "") {
      GridColumn_SettingActions.getSaveFilterValue(item, reportCode);
    }

    if (currentPage !== 1) {
      UpdateCurrentPage(1);
    } else {
      UpdateSortBy("InventarNr");
    }
  };

  function deleteSaveFilter(filterId) {
    setGlobalSpinner(true);

    GridColumn_SettingActions.deleteSavedFilter(filterId, reportCode);
  }

  function handleCloseFilterModal() {
    setShowFilterMenu(false);
  }
  //endregion
  function getEquipmentBasedFilter(filterList) {
    setGlobalSpinner(true);
    const FilterId = null;
    if (filterList.length > 0) {
      if (currentPage === 1) {
        equipmentGroupActions.getEquipmentList2(
          reportCode,
          sortBy.order,
          selectedAnlageG,
          parseInt(1),
          parseInt(pageSize),
          sortBy.key,
          FilterId,
          filterList,
        );
      } else {
        UpdateCurrentPage(1);
      }
    } else {
      updateSelectedFilter("");
      handleDropDownSelChange("");
    }
  }

  function resetClearFilter() {
    setClearFilter(false);
  }

  return (
    <div id="content">
      <h3 className="page-header">
        {sessionStorage.getItem("plant") + " " + " / "}
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to={"/equipmentGrpEqiupment"}
          onClick={() => {
            UpdateSearchQuery(null);
            UpdateSortBy(null);
          }}
        >
          {sessionStorage.getItem("eqBez")}
        </NavLink>
        {" " + " / " + " " + fonctionsname}
      </h3>
      <div className="container-fluid">
        <MessageBox
          isOpen={messageBoxOpen}
          text={messageBoxText}
          functions={msgButtons}
          close={closeMsg}
        />
        <SearchBox_new
          cols={columns}
          isOpen={openSearchBox}
          close={closeMsg}
          Reset={resetFilter}
          resetClearFilter={resetClearFilter}
          clearFilter={clearfilter}
          // selectedSaveFilter={selectedSaveFilter}
          getEquipmentBasedFilter={getEquipmentBasedFilter}
          ReportId={reportCode}
        />
        <HeaderBar
          headerBarControl={headerBarControl}
          paginationStates={openSearchBoxEvent}
          paginatorData={paginatorData}
          dropValueToHeader={dropValueToHeader}
          tablefunctions={tablefunctions}
          _orginalResponse={_orginalResponse}
          handleFilterLocal={handleFilterLocal}
          disabledSavedFilter={disabledSavedFilter}
          gridAction={gridAction}
          handleDropDownSelChange={handleDropDownSelChange}
          deleteSaveFilter={deleteSaveFilter}
          showSearchDialog={showSearchDialog}
          resetClearFilter={resetClearFilter}
        />
        <div className="table-responsive px-3 table-height">{renderTable}</div>
        {headerBarControl.isPaginator && (
          <Paginator
            pageCount={paginatorData.pageCount}
            activePage={paginatorData.activePage}
            setCurrentPage={paginatorData.func1}
            rowCount={paginatorData.rowCount}
            pageSize={paginatorData.pageSize}
            setPageSize={paginatorData.func2}
            firstRowOnPage={paginatorData.firstRowOnPage}
            lastRowOnPage={paginatorData.lastRowOnPage}
          />
        )}
        {showFilterMenu && (
          <GridColumnSettingControl
            handleCloseModel={handleCloseFilterModal}
            pageId={reportCode}
          />
        )}
      </div>
    </div>
  );
};
export default NIOAnlageUebersicht;
